export const defaultLottieOptions = {
  loop: true,
  autoplay: true,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

export const bottomNav = [
  {
    name: "Go Back To Top",
    path: "/",
    isRoute: true
  },
  {
    name: "About Us",
    path: "/about-us",
    isRoute: true
  },
  {
    name: "Careers",
    path: "/careers",
    isRoute: true
  },
  {
    name: "Blog",
    externalPath: "https://coschool.medium.com/",
    isRoute: false
  },
];


export const faqs = [
  {
    title: "What is SchoolAi?",
    data: "Closed-loop learning platform powering schools to deliver stronger academic outcomes",
  },
  {
    title: "What do we do?",
    data: "We enable student learning without knowledge gaps.",
  },
  {
    title: "How do we do it?",
    data: `Through our AI Tutor, Vin, we bring together students, teachers, parents, and school leaders to personalise student learning. 
    <ul>
    <li>Empower teachers to provide personalised, one-on-one support to students</li>
    <li>Enable students to learn at their own pace in a judgement free environment</li>
    <li>Facilitate parents in becoming active participants in their child's education</li>
    <li>Assist school leaders in making swift, informed decisions based on real-time insights</li>
    </ul>`,
  },
  {
    title: `How does SchoolAi empower teachers to provide one-on-one student support?`,
    data: "SchoolAi leverages advanced AI technology to personalize learning for each student. This includes setting learning goals, grading student submissions, and providing detailed insights about individual student learning gaps. Once the gaps are identified, SchoolAi assists teachers with actionable and personalised plans for each student's specific needs."
  },
  {
    title: `How does SchoolAi enable students to learn at their own pace?`,
    data: "SchoolAi enables students to learn at their own pace through Vin, our 24/7 AI Tutor. Vin supports students in completing their homework effectively, adjusting and adapting to each individual's learning speed and style. By providing instant, pointed feedback, Vin helps students immediately identify and address any knowledge gaps. Moreover, Vin is designed to resolve doubts instantly, offering explanations in a judgement-free manner that encourages questions and exploration. This personalised approach ensures that each student progresses based on their unique abilities and comprehension levels, promoting confidence and thorough understanding in their learning journey",
  },
  {
    title: `How are parents integrated into the SchoolAi system?`,
    data: `With SchoolAi, parents are empowered to become active participants in their child’s educational journey. They stay well-informed through real-time updates about their child’s progress and activities. Additionally, SchoolAi engages parents with actionable nudges designed to spark their child's curiosity and enhance learning engagement. Parents can also contribute to a comprehensive 360-degree portfolio by documenting observations and key events, which helps in building a holistic view of the child's educational development.`,
  },
  {
    title: "What do school leaders get in this?",
    data: "School leaders gain access to comprehensive dashboards that provide insights into overall school performance, teacher efficiency, and student progress. These tools support data-driven decision-making, allowing leaders to optimise strategies, resource allocation, and track the school’s achievements and areas for improvement.",
  },
  {
    title: "What grades and curriculums are included in SchoolAi?",
    data: "SchoolAi is currently focused on providing personalised learning for students in grades 8-10 at CBSE-affiliated schools, utilising NCERT publications. We are actively working on expanding our offerings to include additional grades, curriculums, and a wider range of educational publications in the near future to accommodate a broader student base.",
  },
  {
    title: "How does SchoolAi ensure the safety and privacy of student's data?",
    data: "SchoolAi complies with all relevant data protection laws and uses state-of-the-art security measures. Data is encrypted, both in transit and at rest, and access is strictly controlled. Regular security audits and compliance checks ensure that student data remains confidential and secure.",
  },
  {
    title: "How can schools get started with SchoolAi?",
    data: "Schools can begin their journey with SchoolAi by reaching out to us by filling a form for a personalised demonstration. Our team will guide you through a customised implementation process based on your school's specific needs. Starting with SchoolAi does not require complex integration efforts, making the setup straightforward and accessible.",
  },
  {
    title:
      "What support services are provided to schools to ensure their success with SchoolAi?",
    data: "Schools receive comprehensive support to facilitate successful implementation and utilisation of SchoolAi. This includes specialised product training sessions aimed at efficient onboarding, access to training resources for ongoing support, and a dedicated key account manager focused on school success. These resources help schools fully leverage SchoolAi to achieve their educational objectives and improve overall outcomes.",
  },
  {
    title: "What are the costs associated with implementing SchoolAi?",
    data: "The cost of implementing SchoolAi varies based on school size, customisation needs, and specific features required. Please contact our team for a personalised quote.",
  },
];